import React, { Suspense, useEffect, useMemo, useState,useCallback } from 'react'
import CommonSliderSection from './CommonSliderSection';
import {  ActivityIcon, AnnouncementsIcon, BirthdateCalendarIcon, CalendarButtonRightSideShapeIcon, CloseIconBranding, ConnectedDeviceIcon, DashboardStarIcon, FocusIcon, MyWorkoutIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage, PersonalizedWellnessHubIcon, } from '../../utils/icons';
import {  /*CalendarLinkCard,*/ ConnectedDeviceCard, CrossIconContainer, DateAndDayContainer,Divider,DropdownContent,/* DeviceContainer, DeviceContainerWrapper,*/ Layout, MonthlythemeContainer,  OuterCardContainer,  ProgressBarContainer, ReservedButton, TopCards, TopCardsContainer, TopThreeInitiativesCard, WeeklyFocusCard, WeeklyFocusCardContainer } from './styles';

import { connect, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { GetAnnouncementData, GetCompanyCalendarLink, /*GetCompanyRewardTier,*/ GetFocustData, GetTopFourCardsData, GetTopThreeInitiative, GetWellnessPersonalizeCategories, LikeDailyAffirmation,GetUserProductTourDetails, GetUserRewardData } from '../../redux/constants/apiConstants';
import { commaSeperator, fetchApi, hexToRgba,/* findMonth*/} from '../../utils/methods';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { ImageUrl } from '../../utils/constants';
import SkeletonLoder from '../common/skeletonLoder';
import WelcomeModal from '../Content/WelcomeModalV2';
import { /*fetchConnectedDevices, getChallengeCompleted, getCompletedChallenges,getDailyActivityData,getListOfConnectedDevices, getListOfThingsToCompleteAPI,getMonthlyTasks ,getRecommenedThingsToComplete, getStatusForBiometricPopUp, getStatusForHRAPopUp, getUserChallengeInvitationAPI, getUserCompanyItitiatives,userBirthdayAndAnniversary, getUserId, getWellnessAssessment,revokeDevice*/  thanksForTheTipAPI, WelcomeBoxAction } from '../../redux/actions';
import { getProductTourDetails } from '../../redux/actions/userProfileActions'; 
import HraPopUp from '../HraPopUp';
import { isNull } from 'lodash';
import Waiting from '../Waiting';
import Personalize from '../ContentV2/WellnessPillar/Personalize';
import WellnessPillarModal from '../ContentV2/WellnessPillar/WellnessPillarModal';
import LogWorkoutCategoryV3 from '../LogWorkoutCategoryV3';
import ConnectDeviceModal from '../ConnectDeviceModal';
import DeviceConnectedPopup from './DeviceConnectedPopup';
import PersonalizeWellnessPopup from './PersonalizeWellnessPopup';
import { withTranslation } from 'react-i18next';
import LazyImage from '../common/LazyImage/LazyImage';
import UserInitiativePopup from './Initiatives/userInitiativePopup';
import ConfirmDetailsModal from '../ContentV2/SideBarContiner/ConfirmDetailsModal';
import InitiativeCompleteModal from './Initiatives/initiativeCompleteModal';
import { CommonButtonPopup } from '../ReportsV2/styles';
import CustomCalendarLinkBanner from './CalendarLinkBanner';
import TourInitiationPopup from '../ProductTour/TourInitiationPopup';
import TourSkippedPopup from '../ProductTour/TourSkippedPopup';
import TourSteps from '../ProductTour/TourSteps';
import { useProductTour } from '../../hooks/useProductTour';

import { TIER_STYLES } from '../../../mockData';
const BiometricPopUpV3 = React.lazy(() => import('../BiometricPopUpV3'));
const UpdateUserInfoPopup = React.lazy(() => import('../UpdateUserInfoPopup'));
// const BirthdayWish = React.lazy(() => import('../BirthdayWishPopup'));
// const AnniversaryWish = React.lazy(() => import('../WorkAnniversaryWishPopup'));

// const TIER_STYLES = {
//   none: {
//     border: '#DCDCDC',
//     background: '#FEFEFE',
//     progress: '#DA6C74',
//     progressBg: '#F6D5D6',
//     text:'#DA6C74'
//   },
//   bronze: {
//     border: '#DA9B6C',
//     background: '#F7EBDD',
//     progress: '#DA9B6C',
//     progressBg: '#EED5BA',
//     text:'#C06236'
//   },
//   silver: {
//     border: '#BDBDBD',
//     background: '#EFEFEF',
//     progress: '#BDBDBD',
//     progressBg: '#FEFEFE',
//     text:'#7C7C7C'
//   },
//   gold: {
//     border: '#F37A65',
//     background: '#FDE7E3',
//     progress: '#F37A65',
//     progressBg: '#FDD2CB',
//     text:'#EA6149'
//   },
//   platinum: {
//     border: '#989898',
//     background: '#DCDCDC',
//     progress: '#989898',
//     progressBg: '#EFEFEF',
//     text:'#7C7C7C'
//   },
//   finished: {
//     border: '#989898',
//     background: '#DCDCDC',
//     progress: '#989898',
//     progressBg: '#EFEFEF',
//     text:'#7C7C7C'
//   },
// };

const WEEKLY_FOCUS = [
  { key: "mindfulMonday", label: "Mindful Monday", day:'Monday' },
  { key: "toneUpTuesday", label: "Tone-up Tuesday", day:'Tuesday' },
  { key: "wolibaWednesday", label: "Woliba Wednesday", day:'Wednesday'},
  { key: "thankfulThursday", label: "Thankful Thursday", day:'Thursday' },
  { key: "foodieFriday", label: "Foodie Friday", day:'Friday' },
  { key: "stretchSaturday", label: "Stretch Saturday", day:'Saturday'},
  { key: "StillnessSunday", label: "Stillness Sunday", day:'Sunday' },
];

function UserDashboard({role,brandingColor,companyBrandingDetails}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const productTourDetails = useSelector((state) => state.profileData.productTourDetails);
  


  


  const welcomeBoxValue = useSelector((state) => state.register.welcomeBoxValue);
  const showHRAPopUp = useSelector((state) => state.profileData.showHRAPopUp);
  const showBiometricPopUp = useSelector((state) => state.profileData.showBiometricPopUp);
  const companyDetails = useSelector((state) => state.profileData.companyDetails);
  const userName = useSelector((state) => state.profileData.firstName);
  // const birthdayAnniversaryWishModalStatus = useSelector((state) => state.social.birthdayAnniversaryWishStatus);
  const wellnessPillarOnboarding = useSelector((state) => state.profileData?.response?.is_wellbeing_pillar_added);
  const dailyTipData = useSelector((state) => state.profileData.dailyTip);
  const user = useSelector((state) => state.profileData.user);
  const isWolibaCompany = user?.company_id === 1;



  const {
    showTourInitiation,
    showTourSkipped,
    isTourActive,
    startTour,
    skipTour,
    completeTour,
    closeTourSkippedPopup,
    showTourInitiationPopup
  } = useProductTour(productTourDetails, user);


  const updateTourStatus = useCallback(async (completed = false) => {
    if (!user?.company_id) return;
    
    const payload = {
      company_id: user.company_id,
      product_tour_data: {
        user_dashboard: completed,
        admin_dashboard: productTourDetails?.product_tour_data?.admin_dashboard || false
      }
    };
    
    await fetchApi(GetUserProductTourDetails, 'POST', payload);
    dispatch(getProductTourDetails(user.company_id));
  }, [user?.company_id, productTourDetails?.product_tour_data?.admin_dashboard, dispatch]);

  const handleCompleteTour = useCallback(async () => {
    completeTour();
    await updateTourStatus(false);
  }, [completeTour, updateTourStatus]);

  const handleSkipTour = useCallback(async () => {
    skipTour();
    await updateTourStatus(false);
  }, [skipTour, updateTourStatus]);

  const handleHRAPopUp = useCallback(() => {
    setShowHRA('');
    setActiveHRA('false');
    localStorage.setItem('hra_completed', 'true');
    
    const isNewUser = productTourDetails?.is_new_user === true;
    if (isNewUser) {
      const locationDeptCompleted = localStorage.getItem('location_dept_completed') === 'true';
      if (locationDeptCompleted) {
        window.setTimeout(() => showTourInitiationPopup(), 500);
      }
    } else {
      window.setTimeout(() => showTourInitiationPopup(), 500);
    }
  }, [productTourDetails?.is_new_user, showTourInitiationPopup]);


  // const userId = useSelector((state) => state.profileData.userId);
  const devicesDisconnected = useSelector((state) => state.profileData.devicesDisconnected);
  // const devices = useSelector((state) => state.wellnessDashboard.devices);
  const devicesLoading = useSelector((state) => state.wellnessDashboard.devicesLoading);
  const firstName = useSelector((state) => state.profileData.firstName);
  // const wellnessAssessment = useSelector((state) => state.profileData.wellnessAssessment);
  const ShowNewUserDashboard = companyBrandingDetails?.allowed_new_user_dashboard;

  const hideDeviceBanner =
  localStorage.getItem("hide_device_connect_banner") === "true";

  const [topCardsData, setTopCardsData] = useState([]);
  const [isDevieConnected, setIsDevieConnected] = useState([]);
  const [announcementData, setAnnouncementsData] = useState([]);
  const [myActivityData, setMyActivityData] = useState([]);
  const [themeData,setThemeData] = useState({});
  const [dailyTip,setDailyTip] = useState('');
  const [selectedFocusData,setSelectedFocusData] = useState(null);
  const [focusData,setFocusData] = useState({});
  const [focusTitle,setFocusTitle] = useState('');
  const [activeFocusKey, setActiveFocusKey] = useState(null);
  const [showUpdateLightbox, setShowUpdateLightbox] = useState('userInfo');
  const [showHRA,setShowHRA] = useState('HRAPopUp');
  const [activeHRA,setActiveHRA] = useState('true');
  const [showBiometric,setShowBiometric] = useState('Biometric');
  const [activeBiomatric,setActiveBiomatric] = useState('true');
  // const [showBirthdayWishModal, setShowBirthdayWishModal] = useState(true);
  // const [activeBirthday,setActiveBirthday] = useState('true');
  // const [showAnniversaryWishModal, setShowAnniversaryWishModal] = useState(true);
  const [showPersonalizeModal,setShowPersonalizeModal] = useState(false);
  const [showWellnessPillarModal,setShowWellnessPillarModal] = useState(false);
  const [isLoading,setLoading] = useState(true);
  const [focusCardLoading,setFocusCardLoading] = useState(true);
  const [topCardDataLoading,setTopCardDataLoading] = useState(true);
  const [logWorkoutData,setLogWorkoutData]= useState([]);
  const [workoutDate, setWorkoutDate] = useState(null);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [devicePopup,setDevicePopup] = useState(false);
  const [cards, setCards] = useState([]);
  const [showWellnessPopup, setShowWellnessPopup] = useState(false);
  const [wellnessCategory,setWellnessCategory] = useState([]); 
  const [todayFocusKey, setTodayFocusKey] = useState(null);
  const [rewardTier, setRewardTier] = useState(null);
  const [topThreeInitiative, setTopThreeInitiative] = useState([]);
  const[showInitiativeModal,setShowInitiativeModal] = useState(false);
  const[activeInitiative,setActiveInitiative] = useState(null);
  const[showConfirmVisitModal,setShowConfirmVisitModal] = useState(false);
  const[isConfirmDetails, setisConfirmDetails] = useState(false);
  const[calendarLinkDetails, setCalendarLinkDetails] = useState(null);
  const isNewUser = localStorage.getItem("new_user") === "true";
  const [RewardDetails, setRewardDetails] = useState(null);
  // const tierKey = userReward?.tier?.toLowerCase() || 'none';
  // const tierStyle = TIER_STYLES[tierKey] || TIER_STYLES.none;
  

  useEffect(() => {
    const result = generateCards(currentDate, lastDateOfMonth, maxPastDate);
    setCards(result);
  }, [currentDate]);
  

  const today = moment(); 
  const maxPastDate = moment().subtract(14, "days"); // 14–day limit

  const [currentDate, setCurrentDate] = useState(today);
  const lastDateOfMonth = moment().endOf("month");

  // const lastDateOfMonth = moment(currentDate).endOf("month");

  // window.console.log("lastDateOfMonth",lastDateOfMonth)
 
  const nextDay = useMemo(() => moment(currentDate).add(1, "day"), [currentDate]);
  const disablePrev = useMemo(() => {
    if (!cards.length) return true;
    return moment(cards[0].fullDate).isSameOrBefore(maxPastDate, "day");
  }, [cards, maxPastDate]);
  const disableNext = nextDay.isAfter(lastDateOfMonth);
  

  //const connectedDevices = devices.filter((devices) => devices.is_connected);

  const { fontColor, fontFamily,/* backgroundColor,*/ ctaColor } = useSelector(
    (state) => state.theme
  );

  const openWellnessPopup = () => {
    setShowWellnessPopup(true);
  };


  const closeWellnessPopup = () => {
    setShowWellnessPopup(false);
  }


  const closeModal = () => {
    setLogoutPopup(false);
    setWorkoutDate(null);
  }
  const openPopup = () =>{
    setLogoutPopup(true);
  }


  const closeDeviceModal = () => {
    setDevicePopup(false);
    
  }
  const openDevicePopup = () =>{
    setDevicePopup(true);
  }


  const closeRegistrationPopup = () => {
    localStorage.removeItem("new_user");
    localStorage.setItem('onboarding_completed', 'true');
    dispatch(WelcomeBoxAction(false));
    userRegisterStatus();
  };


  const userRegisterStatus = () => {
    // dispatch(getUserId());
    // dispatch(getStatusForBiometricPopUp());
    // dispatch(getDailyActivityData());
    // dispatch(getListOfThingsToCompleteAPI());
    // dispatch(userBirthdayAndAnniversary());
    // dispatch(getRecommenedThingsToComplete());
    // dispatch(getStatusForHRAPopUp());
    // dispatch(getChallengeCompleted());
    // dispatch(getUserCompanyItitiatives());
    // dispatch(getUserChallengeInvitationAPI());

    // if (!wellnessAssessment) {
    //   dispatch(getWellnessAssessment());
    // }
  

    // const d = new Date();
    // const month = findSmallMonth(d.getMonth());
    // const fullMonth = findMonth(d.getMonth());
    // const day = d.getDate();
    // const year = d.getFullYear();
    // const monthInNumber = getCountofCalendar(month, year);

    // your function call
    // getMonth(fullMonth, month, day, year, monthInNumber.month);

    // dispatch(getCompletedChallenges());
    // dispatch(getMonthlyTasks(findMonth(d.getMonth()).toLowerCase()));

    if(wellnessPillarOnboarding === false){
      setShowPersonalizeModal(true);
    }


    // if (completedPopupData && completedPopupData.length > 0) {
    //   setChallengePopupStatus(true); // useState variable in functional
    // }


  }

  useEffect(() => {
    const manualTrigger = localStorage.getItem('start_product_tour');
    if (manualTrigger === 'true' && isWolibaCompany && user?.company_id && !topCardDataLoading) {
      setShowHRA('');
      setActiveHRA('false');
      localStorage.setItem('hra_completed', 'true');
      
      // Wait for DOM to render after data loads
      window.setTimeout(() => {
        startTour();
      }, 500);
    }
  }, [isWolibaCompany, user?.company_id, topCardDataLoading, startTour]);



  useEffect(() => {
    // getTeamChallenges();
    if (!dailyTipData?.id) return;
    if (localStorage.getItem("new_user") === "true") {
      dispatch(WelcomeBoxAction(true));
      if(dailyTipData){
        dispatch(thanksForTheTipAPI(dailyTipData?.id));
        getUserRewardDetails();
      }
    }else {
      if(dailyTipData?.show_tip)
      {
        dispatch(thanksForTheTipAPI(dailyTipData?.id));
        getUserRewardDetails();
      }
      userRegisterStatus();
    }
  }, [dailyTipData]); 
  // useEffect(() => {
  //   const manualTrigger = localStorage.getItem('start_product_tour');
  //   if (manualTrigger === 'true' && productTourDetails && user?.company_id) {
  //     localStorage.removeItem('start_product_tour');
      
  //     if (showHRAPopUp && activeHRA === 'true') {
  //       setShowHRA('');
  //       setActiveHRA('false');
  //       localStorage.setItem('hra_completed', 'true');
  //     }
  //     startTour();
  //   }
  // }, [productTourDetails, user?.company_id, showHRAPopUp, activeHRA]);

  useEffect(() => {
    const manualTrigger = localStorage.getItem('start_product_tour');
    if (manualTrigger === 'true' && !topCardDataLoading && user?.company_id === 1) {
      localStorage.removeItem('start_product_tour');
      
      if (showHRAPopUp && activeHRA === 'true') {
        setShowHRA('');
        setActiveHRA('false');
        localStorage.setItem('hra_completed', 'true');
      }
      startTour();
    }
  }, [topCardDataLoading, user?.company_id, showHRAPopUp, activeHRA, startTour]);






  
  // useEffect(() => {
  //   if (!productTourDetails || !user?.company_id) return;
  //   if (showHRAPopUp === undefined) return;
  //   if (user?.company_id !== 1) return;
    
  //   const isExistingUser = productTourDetails?.is_new_user !== true;
  //   const tourCompleted = productTourDetails?.product_tour_data?.user_dashboard === false;
  //   const hraCompleted = localStorage.getItem('hra_completed') === 'true';
    
  //   if (isExistingUser && !tourCompleted && hraCompleted && showHRAPopUp === false) {
  //     window.setTimeout(() => showTourInitiationPopup(), 1500);
  //   }
  // }, [productTourDetails, user?.company_id, showHRAPopUp, showTourInitiationPopup]);









  // useEffect(() => {
  //   // run only when redux "user" or "completedPopupData" changes
  //   if (!user) return;
  
  //   // ---- REPLACING componentWillReceiveProps logic ----
  //   const createdAt = isNull(user?.reward_date)
  //     ? user?.created_at
  //     : user?.reward_date;
  
  //   if (
  //     convertDateInTimezone(createdAt)
  //       .add(30, "days")._d < momentTZ()._d
  //   ) {
  //     setShowListOfThings(false);
  //   }
  
  //   // check popup data
  //   if (completedPopupData && completedPopupData.length > 0) {
  //     setChallengePopupStatus(true);
  //   }
  
  // }, [user, completedPopupData]);


  useEffect(()=>{
    GetTopCardsData();
    GetAnnouncementsData();
    GetFocusCardData();
    FetchWellnessHubCategories();
    fetchTopThreeInitiative();
    getUserRewardDetails();
  },[])

  // useEffect(()=>{
  //   user?.company_id && fetchCompanyRewardTierDetails(user?.company_id);
  // },[user])

  useEffect(() => {
    if (!user) return;
    if (!user.company_id) return;
    if (user?.company_id) {
      // fetchCompanyRewardTierDetails(user.company_id);
      getCalendarLinkData(user?.company_id)
    }
  }, [user?.company_id]); // Only fires when the actual ID changes

  const getCalendarLinkData = async(companyId) => {
    
    try{
      const res = await fetchApi(`${GetCompanyCalendarLink + "/" + companyId}`, "GET");
      if(res.status === "success"){
        setCalendarLinkDetails(res?.data)
      }else{
        setCalendarLinkDetails(null)
        toast.error(res.message);
      }

    }catch(error){
      toast.error(error.message);
    }
  }


  // const fetchCompanyRewardTierDetails = async(companyId) =>{
  //   try {
  //     const res = await fetchApi(GetCompanyRewardTier+'/'+companyId, "GET");
  //     window.console.log("setRewardTier",res)
  //     if(res?.data?.message){
  //       toast.error(res?.data?.message)
  //     }else{
  //       setRewardTier(res.data?.[0]);
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // }

  const fetchTopThreeInitiative = async() =>{
    try {
      const res = await fetchApi(GetTopThreeInitiative, "GET");
      if(res?.data?.message){
        toast.error(res?.data?.message)
      }else{
        setTopThreeInitiative(res.data);
      }
    } catch (error) {
      toast.error(error);
    }
  }

  const FetchWellnessHubCategories = async()=>{
    try {
      const res = await fetchApi(GetWellnessPersonalizeCategories, "GET");
      if(res.status === 'success'){
        setWellnessCategory(res.data)
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  

  const GetFocusCardData= async () => {
    const apiUrl =GetFocustData ;
    try {
      !activeFocusKey && setFocusCardLoading(true);
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setFocusData(res.data);
        setFocusCardLoading(false);

      }else{
        toast.error(res.message);
        setFocusCardLoading(false);
      }
    }
    catch(error){
      window.console.error(error);
      setFocusCardLoading(false);
    }
  }


  const GetTopCardsData= async () => {
  
    const apiUrl = GetTopFourCardsData;
    try {
      setTopCardDataLoading(true);
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setTopCardsData(res.data);
        setThemeData(res.data.themes);
        setDailyTip(res.data.daily_tip);
        setIsDevieConnected(res.data.is_device_connected)
        setLogWorkoutData(res.data.log_workout_data);
        setTopCardDataLoading(false);
      }else{
        toast.error(res.message);
        setTopCardDataLoading(false);
      }
    }
    catch(error){
      window.console.error(error);
      setLoading(false);
    }
  }

  const GetAnnouncementsData= async () => {
    const apiUrl = GetAnnouncementData;
    setLoading(true);
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setAnnouncementsData(res.data.announcements);
        setMyActivityData(res.data.my_activities);
        setLoading(false);
      }
      else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      window.console.error(error);

    }
  }


  const getUserRewardDetails = async()=>{
    try {
      const res = await fetchApi(GetUserRewardData , "GET");
      window.console.log("getAllCompanyProducts",res)
      if (res.status === "success") {
        setRewardDetails(res.data);
        setRewardTier(res.data?.company_reward_active_thresholds);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const hideLightboxPopup = () => {
    setShowUpdateLightbox('');
  };

  const handleUserInfoUpdate = () => {
    setShowUpdateLightbox('');
    localStorage.setItem('location_dept_completed', 'true');
  };

  

  const handleBiomtricPopUp = () => {
    setShowBiometric('');
    setActiveBiomatric('false');
  };

  // const handleBirthdayWishModal = () => {
  //   setShowBirthdayWishModal((prev) => !prev);
  //   setActiveBirthday('false');
  // }

  // const handleAnniversaryWishModal = () => {
  //   setShowAnniversaryWishModal((prev) => !prev);
  // }

  const handleHidePersonlizeModal = () => {
    setShowWellnessPillarModal(true);
    setShowPersonalizeModal(false);
  };


  // const handleFocusClick = (key) => {
  //   const data = focusData?.[key];
  //   setSelectedFocusData(data);
  //   setActiveFocusKey(key); 
  //   if(key ==="mindfulMonday"){
  //     setFocusTitle("Mindful Monday");
  //   }else if(key ==="wolibaWednesday"){
  //     setFocusTitle("Woliba Wednesday");
  //   }else if(key ==="foodieFriday"){
  //     setFocusTitle("Foodie Friday");
  //   }else if(key ==="StillnessSunday"){
  //     setFocusTitle("Stillness Sunday");
  //   }
  // };



  const handleFocusClick = (key, label) => {
    const data = focusData?.[key];
    setSelectedFocusData(data);
    setActiveFocusKey(key);
  
    // 👇 Only show "Today's Focus" if clicked key === today's key
    if (key === todayFocusKey) {
      setFocusTitle(`Today’s Focus: ${label}`);
    } else {
      setFocusTitle(label);
    }
  };
  
  // const revokeDeviceHandler = (name) => {
  //   dispatch(revokeDevice(name));
  // };
  
  
  useEffect(() => {
    if (!focusData ) return;
    if(activeFocusKey){
      setTodayFocusKey(activeFocusKey);
      setActiveFocusKey(activeFocusKey);
      setSelectedFocusData(focusData[activeFocusKey]);
      return;

    }
  
    const today = moment().format("dddd");
  
    const todayFocus = WEEKLY_FOCUS.find(
      (item) => item.day === today
    );
  
    if (!todayFocus || !focusData[todayFocus.key] ) return;
  
    setTodayFocusKey(todayFocus.key);
    setActiveFocusKey(todayFocus.key);
    setSelectedFocusData(focusData[todayFocus.key]);
    setFocusTitle(`Today’s Focus: ${todayFocus.label}`);
  }, [focusData]);



  const TopCardsComponent = () => {
    // const userPoints = Number(topCardsData?.user_monthly_experience_points) || 0;
    // const totalPoints = Number(topCardsData?.total_monthly_experience_points) || 1; 
    // const progressPercent = Math.min((userPoints / totalPoints) * 100, 100);
 

    const userHealthWellnessPoints = Number(topCardsData?.user_health_and_wellness_points) || 0;
    const totalUserHealthWellnessPoints = Number(topCardsData?.total_health_and_wellness_points) || 1; 
    const progressHealthWellnessPercent = Math.min((userHealthWellnessPoints / totalUserHealthWellnessPoints) * 100, 100);
   
    const noHealthInitiative =  topCardsData?.user_health_and_wellness_points === 0 && topCardsData?.total_health_and_wellness_points === 0;
    // const completedHealthInitiative  = true
    const completedHealthInitiative =  topCardsData?.user_health_and_wellness_points === 5000 && topCardsData?.total_health_and_wellness_points === 5000;
    const earnedPoints=Number(RewardDetails?.user_total_points_sum) || 0;
    const userTier =earnedPoints >= rewardTier?.finished ? 'finished' : earnedPoints >= rewardTier?.gold ? 'gold' : earnedPoints >= rewardTier?.silver ? 'silver' : earnedPoints >= rewardTier?.bronze ? 'bronze' :earnedPoints >= rewardTier?.silver ? 'none' : null;

    const tierKey = userTier || 'none';
    const tierStyle = TIER_STYLES[tierKey] || TIER_STYLES.none;

    const TIER_RANGES = {
      none:    { min: 0, max: Number(rewardTier?.bronze) },
      bronze:  { min: rewardTier?.bronze, max: rewardTier?.silver },
      silver:  { min: rewardTier?.silver, max: rewardTier?.gold },
      gold:    { min: rewardTier?.gold, max: rewardTier?.finished },
      finished:{ min: rewardTier?.finished, max: rewardTier?.finished }
    };


    const bronze = Number(rewardTier?.bronze) || 0;
    const silver = Number(rewardTier?.silver) || 0;
    const gold = Number(rewardTier?.gold) || 0;
    const finished = Number(rewardTier?.finished) || 0;
    
    const { min, max } = TIER_RANGES[userTier || 'none'] || {};

    const progressPercent = userTier === 'finished' ? 100 : Math.min(Math.max(((earnedPoints - min) / (max - min)) * 100, 0),100);
    
    return (
      <TopCardsContainer>
        <TopCards fontColor={fontColor} fontFamily={fontFamily} data-tour="wellness-tip">
          <div className="headingContainer">
            <div className="iconContainer">{DashboardStarIcon()}</div>
            <div className="wellnessTipHeading">Your Daily Wellness Tip</div>
          </div>
          <div className="wellnessTipText">{dailyTip?.daily_tip}</div>
        </TopCards>

        <TopCards fontColor={fontColor} fontFamily={fontFamily} data-tour="health-goals">
          <div className="headingContainer">
            <div className="iconContainer">{DashboardStarIcon()}</div>
            <div className="wellnessTipHeading">Health and Wellness Goals </div>
          </div>
          <div className="pointsText">{commaSeperator(topCardsData?.user_health_and_wellness_points)} / {commaSeperator(topCardsData?.total_health_and_wellness_points)} XP Points</div>
          {noHealthInitiative ? <div className="noHealthData"> Your company hasn&apos;t launched a health <br/>initiative yet.</div> 
            : completedHealthInitiative ? <div className="congratesText">Congratulations you have earned all <br/>the health and wellness points!</div>  :<ProgressBarContainer ctaColor={ctaColor} progressPercent={progressHealthWellnessPercent}>
              <div className="progress"></div>
            </ProgressBarContainer> }
          <div className='top-initiatives'><div className='top-three-initiatives'>{Object.entries(topThreeInitiative).map(([key, initiative])=>(                      
            <TopThreeInitiativesCard background={initiative?.color} key={key} onClick={()=>{setShowInitiativeModal(true);setActiveInitiative(initiative)}}>
              <div className="icon">
                <img
                  className='initiative-image'
                  src={`${ImageUrl}/${initiative?.initiative_white_icon}`}
                  alt={initiative?.name || "initiative"}
                  onError={(e) => { e.currentTarget.src = `${ImageUrl}/default-initiative.png`; }}
                />
              </div><div className="tooltip">{initiative?.name}</div></TopThreeInitiativesCard>
          ))}</div><div className="redirectionText"  onClick={()=> history.push({pathname:"/profile",state:{key:7}})}>{"Track Goals >"}</div></div>
          
        </TopCards>

        <TopCards fontColor={fontColor} fontFamily={fontFamily} tierStyle={tierStyle} redirectionTextColor={tierStyle.text} data-tour="experience-points">
          <div className="headingContainer">
            <div className="iconContainer">{DashboardStarIcon()}</div>
            <div className="wellnessTipHeading">Experience Points</div>
          </div>
          {/* <div className="pointsText">{userPoints} / {totalPoints} XP Points</div> */}
          <div className='rewards-point'>
            <LazyImage src={ImageUrl + `/images/Rewards/new-${userTier === 'finished' ? 'platinum' : userTier || 'no-badge'}.png`} style={{width:'44px'}}/>
            <div className='tier-details'>
              
              {/* <div className='active-tier'>{commaSeperator(userTier ? rewardTier?.[userTier] : rewardTier?.bronze)} XP {userTier === 'finished' ? 'Platinum' : userTier}</div> */}
              <div className='active-tier'>{commaSeperator(earnedPoints)} total XP earned</div>

              <div className='next-tier'>{userTier === 'finished' ? `You have achieved ${commaSeperator(earnedPoints)} XP` : userTier === 'gold' ? `${commaSeperator(finished - earnedPoints)} points to complete ` : commaSeperator(userTier == 'bronze' ? silver - earnedPoints : userTier == 'silver' ? gold - earnedPoints :  userTier == 'gold' ? finished - earnedPoints : bronze - earnedPoints)}                 
              
                {userTier != 'finished' && userTier != 'gold'  ? ' points away from ' : null } 
              
                {userTier == 'bronze' ? 'silver' : userTier == 'silver' ? 'gold' : userTier == 'gold' ? 'platinum' :  userTier == 'finished' ? '' :'bronze' }</div>

            </div>

          </div>
          <ProgressBarContainer  progressPercent={progressPercent} tierStyle={tierStyle}> 
            <div className="progress"></div>
          </ProgressBarContainer>
          <div style={{marginTop:'10px'}} className="redirectionText"  onClick={()=> history.push({pathname:"/profile",state:{key:2}})}>{"View Achievements >"}</div>
        </TopCards>
      </TopCardsContainer>)}

  const Announcements = () => (
    <CommonSliderSection
      title="Announcements"  
      refreshAnnouncements={GetAnnouncementsData} 
      data={announcementData} showArrows={true} 
      showDots={true}
      myAnnouncementCard={true}  
      loading={isLoading} 
      icon={<AnnouncementsIcon/>}
    />
  );

  // const CalendarLinkBanner = () => {
  //   if (!calendarLinkDetails?.link) return null;
  
  //   return (
  //     <>
  //       <CalendarLinkCard>
  //         <div className='text'>Schedule with the {user?.company_name} team</div>
  //         <CommonButtonPopup
  //           as="a"
  //           href={calendarLinkDetails?.link}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //           height="48px"
  //           // width="100%"
  //           margin="0 13.5% 0 0"
  //           // onClick={isValid ? this.onSubmit : null}
  //           style={{
  //             backgroundColor: brandingColor ? brandingColor : '#75B084',
  //             minWidth:"300px"
  //           }}
  //         >
  //           {calendarLinkDetails?.label || "Calendar Link"}
  //         </CommonButtonPopup>

  //       </CalendarLinkCard>
  //     </>
  //   );
  // };

  const WeeklyFocusCards = () => {
    if (!selectedFocusData) return null;
  
    return (
      <CommonSliderSection 
        title={focusTitle}
        data={[selectedFocusData]}
        showArrows={false}
        showDots={false}
        myFocusCard={true}
        activeFocusKey={activeFocusKey}
        loading={focusCardLoading} 
        icon={<FocusIcon/>}
        likeAffirmation={likeAffirmation}
      />
    );
  };

  const likeAffirmation = async(payload)=>{
    try{
      const res = await fetchApi(LikeDailyAffirmation,"POST",payload);

      if(res.success === 'success'){
        GetFocusCardData()
        // setSelectedFocusData((prev) => ({
        //   ...prev,
        //   likes: res.data,
        // }));
        // toast.success(res.data[0]);
      }else{
        toast.error(res?.data?.message)
      }
    }catch (error) {
      window.console.error(error);
    }
  }


  const MyActivities = () => (
    <CommonSliderSection 
      title="My Activities" 
      data={myActivityData} 
      showArrows={true} 
      showDots={true} 
      myActicityCard={true}
      loading={isLoading} 
      icon={<ActivityIcon/>}
    />
  );

  

  // const fetchConnectedDevicesHandler = () => {
  //   dispatch(fetchConnectedDevices());
  //   dispatch(getListOfConnectedDevices());
  // };

  const openConnectDevice = () => {
    // fetchConnectedDevicesHandler()
    setShowDeviceModal(true)
  };

  const hideDeviceModal = () => {
    setShowDeviceModal(false)
    // this.setState({ showDeviceModal: false });
  };

  // const displayDeviceModal = () => {
  //   this.props.fetchConnectedDevices();
  //   setShowDeviceModal(true)
  //   // this.setState({ showDeviceModal: true })
  // };


  // const today = moment();
  // const fourteenDaysAgo = moment().subtract(14, "days"); // limit

  // // Start with today as the ending point of visible range
  // const [startDate, setStartDate] = useState(moment().subtract(9, "days")); 
  // const [endDate, setEndDate] = useState(moment()); 

  // Generate 10 cards between startDate and endDate
  // const generateDates = () => {
  //   let dates = [];
  //   let current = moment(startDate);

  //   while (current <= endDate) {
  //     dates.push({
  //       date: current.format("D"),
  //       day: current.format("ddd"),
  //       fullDate: current.clone()
  //     });
  //     current.add(1, "day");
  //   }
  //   return dates;
  // };

  // const dateList = generateDates();

  // ------------ ARROW HANDLERS ------------

  // const goPrev = () => {
  //   const newStart = moment(startDate).subtract(1, "day");
  //   const newEnd = moment(endDate).subtract(1, "day");

  //   if (newStart.isBefore(fourteenDaysAgo)) return; // block going beyond 14-day limit

  //   setStartDate(newStart);
  //   setEndDate(newEnd);
  // };

  // const goNext = () => {
  //   const newStart = moment(startDate).add(1, "day");
  //   const newEnd = moment(endDate).add(1, "day");

  //   if (newEnd.isAfter(today)) return; // block future days

  //   setStartDate(newStart);
  //   setEndDate(newEnd);
  // };

  // Disable Buttons Conditions
  // const isPrevDisabled = startDate.isSameOrBefore(fourteenDaysAgo);
  // const isNextDisabled = endDate.isSameOrAfter(today);

  const handleLogWorkoutPopup = (d) => {
    const isWorkOutDate = d.fullDate.format("YYYY-MM-DD");
    setWorkoutDate(isWorkOutDate);
    openPopup();
  }

 
  // --- Generate 10 cards based on current date ---
  // const cards = useMemo(() => {
  //   let arr = [];
  //   for (let i = 0; i < 10; i++) {
  //     let date = moment(currentDate).add(i, "days"); // next days
  //     if (date.isAfter(lastDateOfMonth)) break;
  //     arr.push({
  //       date: date.date(),
  //       day: date.format("ddd"),
  //       fullDate: date
  //     });
  //   }
  //   while (arr.length < 10) {
  //     let first = moment(arr[0].fullDate).subtract(1, "day");
  //     if (first.isBefore(maxPastDate)) break; // avoid exceeding 14–day limit
  
  //     arr.unshift({
  //       date: first.date(),
  //       day: first.format("ddd"),
  //       fullDate: first
  //     });
  //   }
  //   return arr;
  // }, [currentDate]);


  const generateCards = (currentDate, lastDateOfMonth, maxPastDate) => {
    const arr = [];
    const current = moment(currentDate);
  
    arr.push({
      date: current.date(),
      day: current.format("ddd"),
      fullDate: current,
    });
  
    let prevOffset = 1;
    let nextOffset = 1;
  
    while (arr.length < 10) {
      const prevDay = moment(current).subtract(prevOffset, "day");
      if (prevDay.isSameOrAfter(maxPastDate, "day")) {
        arr.unshift({
          date: prevDay.date(),
          day: prevDay.format("ddd"),
          fullDate: prevDay,
        });
        prevOffset++;
        continue;
      }
  
      const nextDay = moment(current).add(nextOffset, "day");
      if (nextDay.isSameOrBefore(lastDateOfMonth, "day")) {
        arr.push({
          date: nextDay.date(),
          day: nextDay.format("ddd"),
          fullDate: nextDay,
        });
        nextOffset++;
        continue;
      }
  
      // If neither prev nor next can be added, break
      break;
    }
  
    return arr;
  };

  const goPrev = () => {
    const prevDate = moment(currentDate).subtract(1, "day");
    if (prevDate.isBefore(maxPastDate, "day")) return;
  
    const newCards = generateCards(prevDate, lastDateOfMonth, maxPastDate);
    setCards(newCards);
    setCurrentDate(prevDate);
  };

  const goNext = () => {
    if (disableNext) return;
    const nextDate = moment(currentDate).add(1, "day");
    // Prevent going beyond lastDateOfMonth
    if (nextDate.isAfter(lastDateOfMonth, "day")) return;
    // Update current date
    setCurrentDate(nextDate);
    // Regenerate 10-day cards window
    const newCards = generateCards(nextDate, lastDateOfMonth, maxPastDate);
    setCards(newCards);
  };

  // const goNext = () => {
  //   if (disableNext) return; 
  //   const nextDay = moment(currentDate).add(1, "day");
  //   // prevent going beyond today
  //   // if (nextDay.isAfter(today)) return;
  //   if (nextDay.isAfter(lastDateOfMonth)) return;

  //   setCurrentDate(nextDay);
  // };

  // const goPrev = () => {
  //   if (disablePrev || prevDay.isBefore(maxPastDate)) return;  // same logic, just pre-computed earlier
  //   setCurrentDate(moment(currentDate).subtract(1, "day"));
  // };


  // const goNext = () => {
  //   if (disableNext) return; 
  //   setCurrentDate(moment(currentDate).add(1, "day"));
  // };
  

  const workoutStatusMap = useMemo(() => {
    const map = {};
    logWorkoutData.forEach((item) => {
      map[moment(item.date).format("YYYY-MM-DD")] = item.is_logged;
    });
    return map;
  }, [logWorkoutData]);


 


  // const monthName = useMemo(() => {
  //   if (cards.length === 0) return "";
  //   const first = cards[0].fullDate;
  //   const last = cards[cards.length - 1].fullDate;
  //   const sameMonth = first.isSame(last, "month");
  
  //   if (sameMonth) {
  //     // Single month: "Dec 2025"
  //     return first.format("MMM YYYY");
  //   } else {
  //     const firstMonth = first.format("MMM");
  //     const lastMonth = last.format("MMM");
  //     const year = last.format("YYYY"); 
  
  //     return `${firstMonth} – ${lastMonth} ${year}`;
  //   }
  // }, [cards]);

  const monthName = useMemo(() => {
    if (cards.length === 0) return "";
  
    const first = cards[0].fullDate;
    const last = cards[cards.length - 1].fullDate;
  
    const sameMonth = first.isSame(last, "month");
    const sameYear = first.isSame(last, "year");
  
    if (sameMonth) {
      // Dec 2025
      return first.format("MMM YYYY");
    }
  
    if (sameYear) {
      // Dec – Feb 2025
      return `${first.format("MMM")} – ${last.format("MMM")} ${last.format("YYYY")}`;
    }
  
    // ✅ Cross-year case: Dec 2025 – Jan 2026
    return `${first.format("MMM YYYY")} – ${last.format("MMM YYYY")}`;
  }, [cards]);

  // const showDeviceBanner = !devicesLoading && connectedDevices.length === 0 && !hideDeviceBanner;
  const showDeviceBanner = !devicesLoading && !isDevieConnected && !hideDeviceBanner;

  const tourSteps = useMemo(() => {
    const allSteps = [
      { title: 'Monthly Theme', description: 'Explore this month\'s wellness focus with curated content, challenges, and activities designed to support your well-being.', selector: '[data-tour="monthly-theme"]' },
      { title: 'Connect Your Fitness Device', description: 'Sync your fitness device to track activity and personalize your Woliba experience.', selector: '[data-tour="wellness-device"]' },
      { title: 'Your Daily Wellness Tip', description: 'Get a daily wellness tip to support mindfulness, reduce stress, and build small habits that improve your day.', selector: '[data-tour="wellness-tip"]' },
      { title: 'Health and Wellness Goals', description: 'Log company initiatives, view health data, and track your general wellness information.', selector: '[data-tour="health-goals"]' },
      { title: 'Experience Points', description: 'Earn points by completing activities that support your holistic wellbeing and track progress as you reach new levels.', selector: '[data-tour="experience-points"]' },
      { title: 'Announcements', description: 'See the latest company updates, wellness initiatives, challenges, events, and more to earn rewards.', selector: '[data-tour="announcements"]' },
      { title: 'Daily Wellness Focus', description: 'Each day highlights a wellness focus with curated activities to keep you consistent and motivated.', selector: '[data-tour="focus-cards"]' },
      { title: 'Track Your Workouts', description: 'Log workouts, track your daily activity, and stay on top of your fitness progress — all while earning points.', selector: '[data-tour="workout-section"]' },
      { title: 'Personalized Wellness Hub', description: 'Tell us what matters most to you, and we\'ll build a wellness hub around your goals — with personalized resources like videos, recipes, articles, and more', selector: '[data-tour="wellness-hub"]' }
    ];
    
    return allSteps.filter((_, index) => {
      if (index === 1 && !showDeviceBanner) return false;
      if (index === 5 && !announcementData.length) return false;
      return true;
    });
  }, [showDeviceBanner, announcementData.length]);



  return (

    isNewUser ? (
      <WelcomeModal
        showModal={welcomeBoxValue ? true : false}
        closeModal={closeRegistrationPopup} 
        // closeModal={() => {
        //   localStorage.removeItem("new_user");
        //   dispatch(WelcomeBoxAction(false));
        //   userRegisterStatus();
        // }}
        name={user && user.fname}
      />
    ) :
      (<div style={{maxWidth: "1246px", padding: "24px 0px 40px 0px",margin: "auto",width: "100%"}}>
  
        { topCardDataLoading ? <SkeletonLoder width="1248px" height="134px" style={{ marginBottom: "20px" }} /> :
          <MonthlythemeContainer data-tour="monthly-theme"
            backgroundImage={`${ImageUrl}/web/svg/${themeData?.image_url}`}
            fontColor={themeData?.background_color}
          >
            <div className="insideContainer">
              <div className="monthly-theme-text">{themeData?.month}&apos;s Monthly Theme</div>
              <div className="focus-on-fitness-text">{themeData?.theme_text}</div>
            </div>
          </MonthlythemeContainer>
        }
        <div data-tour="wellness-device">
          { devicesLoading ? (
            <SkeletonLoder width="1248px" height="264px" style={{ marginBottom: "20px" }} />) :
          
            (isDevieConnected || hideDeviceBanner )? null : (<ConnectedDeviceCard bgImage={`/public/images/NewDashboardV2/gradiuntBg.png`} >
              <div className="insideContainer">
                <div className="firstContainer">
                  <div className="deviceHeading">
                    <div className="iconContainer">{ConnectedDeviceIcon()}</div>
                    <div className="headingText">Connect Your Wellness Devices</div>
                  </div>
                  <div className="headingSubText">Sync your activity and wellness data to personalize your<br/> Woliba experience.</div>
                  <ReservedButton
                    active={1}
                    margin={"20px 0 0 0"}
                    onClick={() => openConnectDevice()}
                  >
                    Connect Device
                  </ReservedButton>
                </div>
                <div className="secondContainer">
                  
                  <CrossIconContainer style={{cursor:"pointer",zIndex:"1000"}} onClick={()=> openDevicePopup()}>
                    {CloseIconBranding("#DA6C74")}
                  </CrossIconContainer>
          
                </div>
              </div>
            </ConnectedDeviceCard> )   }
        </div>
        {topCardDataLoading ? <SkeletonLoder width="100%" height="200px" style={{ marginBottom: "20px" }} /> : TopCardsComponent()}
        <div data-tour="announcements">
          {announcementData.length ?  Announcements() : null}
        </div>
        {/* {calendarLinkDetails ? CalendarLinkBanner() : null} */}
        {calendarLinkDetails && companyDetails?.id === 1 ? <CustomCalendarLinkBanner
          bgColor={hexToRgba(calendarLinkDetails?.color || brandingColor || '#75B084',"10%")}
          shapeColor={calendarLinkDetails?.color || brandingColor || '#75B084'}
          textColor={calendarLinkDetails?.color || brandingColor || '#75B084'}
          color={calendarLinkDetails?.color || brandingColor || '#75B084'}
          text={calendarLinkDetails?.text || (!ShowNewUserDashboard ? "Schedule with COR Wellness" : "Schedule A Meeting With A Coach ")}
          rightButton={          <CommonButtonPopup
            as="a"
            href={calendarLinkDetails?.link}
            target="_blank"
            rel="noopener noreferrer"
            height="48px"
            // width="100%"
            margin="0 13.5% 0 0"
            // onClick={isValid ? this.onSubmit : null}
            style={{
              backgroundColor: calendarLinkDetails?.color || brandingColor || '#75B084',
              minWidth:"300px",
              borderRadius:'6px'
            }}
          >
            {BirthdateCalendarIcon('white')} {"Schedule an appointment"}
            {/* calendarLinkDetails?.label || "Calendar Link" */}
          </CommonButtonPopup>}
          rightIcon={CalendarButtonRightSideShapeIcon(calendarLinkDetails?.color || brandingColor || '#75B084')}
        />:null}

       
        <div data-tour="focus-cards">
          {focusCardLoading ?  <SkeletonLoder width="100%" height="100px" style={{ margin: "20px 0" }}/>
            : 
            <WeeklyFocusCardContainer  >
              {WEEKLY_FOCUS.map(({ key, label }) => {
                const isActive = activeFocusKey === key;
              
                return (
                  <WeeklyFocusCard
                    key={key}
                    activeCard={isActive ? "#DA6C74" : "white"}
                    isActive={isActive}
                    onClick={() => handleFocusClick(key, label)}
                  >
                    <div className="textContainer">{label}</div>
                  </WeeklyFocusCard>
                );
              })}
            </WeeklyFocusCardContainer>}
            
          {WeeklyFocusCards()}
        </div>
        {/* <div data-tour="my-activities"> */}
        { myActivityData.length ?  MyActivities(): null}
        {/* </div> */}
        
        {topCardDataLoading ? <SkeletonLoder width="1248px" height="304px" style={{ marginTop:"20px" }} />:
          <OuterCardContainer isOuterpadding={"20px"} data-tour="workout-section">
            <Layout margin="0" padding="0px" isFontSize={"16px"}>
              <div className="headingMain">
                <div style={{ gap: "12px" }} className="heading">
                  <MyWorkoutIcon />
                  My Workouts
                </div>
                <div
                  className="redirectionText"
                  onClick={()=> history.push({pathname:"/profile",state:{key:6}})}
                >
                  {"View Workouts >"}
                </div>
              </div>
              <div className="insideCard">
                <div className="monthName">{monthName}</div>
                <div className="monthlyDataContainer">
                  <div
                    className="iconContainer"
                    onClick={!disablePrev ? goPrev : null}
                    style={{ opacity: disablePrev ? 0.3 : 1, pointerEvents: disablePrev ? "none" : "auto" }}
                  >
                    {NewBackArrowIconEventPage("#DA6C74")}
                  </div>
                
                  {cards.map((d, i) => {
                    const formatted = d.fullDate.format("YYYY-MM-DD");
                    const isFuture = d.fullDate.isAfter(today, "day");
                    let color = "#A62F3D"; 
                  
                    if (isFuture) {
                      color = "#7C7C7C"; 
                    } else if (workoutStatusMap[formatted] === true) {
                      color = "#2F6C42";
                    }
                  
                    return (
                      <DateAndDayContainer key={i} color={color} isBg={isFuture ? "#F8F8F8" : "#FEFEFE"}  isCursor={isFuture ? "not-allowed" : "pointer"} onClick={isFuture ? null : ()=> handleLogWorkoutPopup(d)}>
                        <div className="dateText">{d.date}</div>
                        <div className="dayText">{d.day}</div>
                      </DateAndDayContainer>
                    );
                  })}
                  <div
                    className="iconContainer"
                    onClick={!disableNext ? goNext : null}
                    style={{ opacity: disableNext ? 0.3 : 1, pointerEvents: disableNext ? "none" : "auto" }}
                  >
                    {NewNextArrowIconEventPage("#DA6C74")}
                  </div>
                </div>
      
                <ReservedButton
                  active={1}
                  onClick={() => openPopup()}
                >
                  Log Workout
                </ReservedButton>
              </div>
      
            </Layout>
          </OuterCardContainer>}
  
        <OuterCardContainer isOuterpadding={"20px"} data-tour="wellness-hub">
          <Layout margin="0" padding="0px" isFontSize={"16px"}>
            <div className="headingMain">
              <div style={{ gap: "12px" }} className="heading">
                <PersonalizedWellnessHubIcon/>
                Personalized Wellness Hub
              </div>
            </div>
            <Divider  isMargin={"20px 0px"}></Divider>
            {wellnessCategory?.length > 0 ?  
              <div className="dropdown-wrapper">
                {wellnessCategory?.map((data, index) => (
                  <DropdownContent isBorder={"0.75px solid #DCDCDC"} key={index} onClick={() => history.push({pathname:`/wellness-resources/${data?.type}`,state:{categoryData:data}})}>
                    {/* <div>{NewNextArrowIconEventPage()}</div> */}
                    <img src={`${ImageUrl}/${data?.image}`} />
                    <div className="listContent">{data?.category_name || data?.recipe_tag}</div>
                  </DropdownContent>))}
                <div className="redirectionText"  onClick={()=> history.push("/wellness-resources")} style={{marginLeft:"auto"}}>{"View Wellness Hub >>"}</div>
              </div>
              : <> 
                <div className="fallback-wrapper">
                  <div> 
                    <div className="wellnessText">Tell us what matters most and we’ll build a wellness hub around your goals.</div>
                    <ReservedButton
                      active={1}
                      margin={"20px 0 30px 0"}
                      onClick={() => openWellnessPopup()}
                    >
                      Personalize My Hub
                    </ReservedButton>
                  </div>
                  <img
                    src={ImageUrl + "/education/wellness-hub.png"}
                    alt="side visual"
                    className="rightImage"
                  />
                </div>
              </> }
  
          </Layout>
        </OuterCardContainer>
  
  
        {<PersonalizeWellnessPopup   showWellnessPopup={showWellnessPopup}  openPopup={openWellnessPopup}    closePopup={closeWellnessPopup} FetchWellnessHubCategories={FetchWellnessHubCategories} />}
    
  
        {/* Log Workout Popup */}
        {
          logoutPopup && <Suspense fallback={<Waiting/>}><LogWorkoutCategoryV3 title="Add Your Monthly Workout" subContent="Dashboard / monthly workout" showModal={logoutPopup} onHide={closeModal} history={history} closeModal={closeModal}  workoutDate={workoutDate}  GetTopCardsData={GetTopCardsData} firstName={firstName} /></Suspense>
        }
       
  
        {
          !isNull(companyDetails) && companyDetails.show_biometric === 1  && showBiometricPopUp && activeBiomatric && <Suspense fallback={<SkeletonLoder/>}><BiometricPopUpV3 showModal={showBiometric === 'Biometric'} onHide={handleBiomtricPopUp} user={user} history={history} /></Suspense>
        }
  
  
        {/* Health Risk Assesment Popup */}
        {
          !localStorage.getItem('start_product_tour') && 
          (showBiometric === 'false' || !showBiometricPopUp) && 
          showHRAPopUp && 
          activeHRA && 
          <Suspense fallback={<SkeletonLoder/>}>
            <HraPopUp showModal={showHRA === 'HRAPopUp'} onHide={handleHRAPopUp} history={history} />
          </Suspense>
        }
  
        {/* Welcome popup */}
        {user && user.accepted_privacy_policy &&
          <WelcomeModal showModal={welcomeBoxValue ? true : false}  closeModal={(bool) => dispatch(WelcomeBoxAction(bool))} name={user && user.fname} />
        }
  
  
        {/* User information popup for updating location and department */}
        {user && user.accepted_privacy_policy && user.rid !== 3 && user.user_type === 0 && role != 'ADMIN' &&
          <Suspense fallback={<SkeletonLoder/>}>
            <UpdateUserInfoPopup
              showModal={user && user.accepted_privacy_policy && showUpdateLightbox === 'userInfo'}
              companyId={user &&user.company_id}
              userLocation={user && user.city_state_id}
              userDepartment={user && user.department_id}
              onClose={hideLightboxPopup}
              onUpdate={handleUserInfoUpdate}
            />
          </Suspense>
        }

  
        {/* {
          (showBiometric === 'false' || !showBiometricPopUp) && showBirthdayWishModal && birthdayAnniversaryWishModalStatus && birthdayAnniversaryWishModalStatus.birthday  &&
             <Suspense fallback={<Waiting/>}>
               <BirthdayWish
                 onClose={handleBirthdayWishModal}
                 showModal={showBirthdayWishModal}
  
                 data={userName}
               />
             </Suspense>
        }
        {
          (showBiometric === 'false' || !showBiometricPopUp) && (birthdayAnniversaryWishModalStatus.birthday == null || activeBirthday == 'false') && showAnniversaryWishModal && birthdayAnniversaryWishModalStatus && birthdayAnniversaryWishModalStatus.work_anniversary  && 
          <Suspense fallback={<Waiting/>}>
            <AnniversaryWish
              onClose={handleAnniversaryWishModal}
              showModal={showAnniversaryWishModal}
              anniversaryDate={birthdayAnniversaryWishModalStatus.work_anniversary}
              data={userName}
            />
          </Suspense>
        } */}
  
    
        {/* connect device modal */}
        <Suspense fallback={<Waiting/>}>
          <ConnectDeviceModal
            showModal={showDeviceModal}
            closeModal={hideDeviceModal}
            // devices={devices}
            // revokeDevice={revokeDeviceHandler}
            devicesDisconnectedList={devicesDisconnected}
          />
        </Suspense>
  
  
        {/* device connect popup after closing the banner  */}
        {devicePopup && <DeviceConnectedPopup devicePopup={devicePopup}  openPopup={openDevicePopup} history={history}  openConnectDevice={openConnectDevice} closeModal={closeDeviceModal}   title={"Device Not Connected !"}  connected={false}/>}
  
        {/* popups for seleting wellbeing pillar */}
        { showPersonalizeModal && <Personalize showModal={showPersonalizeModal} fname={userName}  onHide={handleHidePersonlizeModal}   />}
        {showWellnessPillarModal && <WellnessPillarModal showModal={showWellnessPillarModal} fname={userName} onHide={()=>{setShowWellnessPillarModal(false)}}/>}
        {showInitiativeModal && <UserInitiativePopup
          showPopup={showInitiativeModal}
          initiativeData={activeInitiative}
          history={history}
          user={user}
          onClose={()=>setShowInitiativeModal(false)}
          showConfirmVisitModal={()=>{setShowConfirmVisitModal(true);setShowInitiativeModal(false)}}
          title={'Recommended To Complete'}
        />}

        {showConfirmVisitModal && <ConfirmDetailsModal showConfirmVisitModal={showConfirmVisitModal} hideConfirmVisitModal={()=>setShowConfirmVisitModal(false)} showIsConfirmDetails={()=>{setisConfirmDetails(true);setShowConfirmVisitModal(false)}} hideIsConfirmDetails={()=>setisConfirmDetails(false)} initiativeData={activeInitiative} name={user?.fname} getUserCompanyItitiatives={fetchTopThreeInitiative} />}
        {isConfirmDetails && <InitiativeCompleteModal isConfirmDetails={isConfirmDetails} initiativeData={activeInitiative} hideIsConfirmDetails={()=>setisConfirmDetails(false)}/>}
        {isWolibaCompany && (
          <>
            <TourInitiationPopup
              showModal={showTourInitiation}
              onTakeTour={startTour}
              onSkipTour={handleSkipTour}
              onClose={handleSkipTour}
              isNewUser={productTourDetails?.is_new_user === true}
            />

            <TourSkippedPopup
              showModal={showTourSkipped}
              onClose={closeTourSkippedPopup}
            />

            <TourSteps
              isActive={isTourActive}
              onComplete={handleCompleteTour}
              tourSteps={tourSteps}
            />
          </>
        )}




      </div>)

  )
}


UserDashboard.propTypes = {
  history: PropTypes.object.isRequired,
  role:PropTypes.string,
  use:PropTypes.object,
  userReward:PropTypes.object,
  brandingColor:PropTypes.string,
  companyBrandingDetails:PropTypes.object
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
  userReward: state.wellnessDashboard.reward,
  brandingColor:state.wellnessDashboard.brandingColor,
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
})


export default connect(mapStateToProps, null)(withTranslation()(UserDashboard));




